// Product color configuration
export const productColorOptions = [
  { value: 'blue', label: 'Blue' },
  { value: 'purple', label: 'Purple' },
  { value: 'orange', label: 'Orange' },
  { value: 'green', label: 'Green' },
  { value: 'red', label: 'Red' },
  { value: 'emerald', label: 'Emerald' },
  { value: 'cyan', label: 'Cyan' },
  { value: 'pink', label: 'Pink' },
  { value: 'yellow', label: 'Yellow' },
  { value: 'indigo', label: 'Indigo' }
];

// Helper function to get color classes
export const getColorClasses = (color) => {
  const colorMap = {
    blue: {
      border: 'border-blue-500/30 hover:border-blue-500/50',
      bg: 'bg-blue-500/20',
      gradient: 'from-blue-500/10 to-blue-600/5',
      text: 'text-blue-400'
    },
    purple: {
      border: 'border-purple-500/30 hover:border-purple-500/50',
      bg: 'bg-purple-500/20',
      gradient: 'from-purple-500/10 to-purple-600/5',
      text: 'text-purple-400'
    },
    orange: {
      border: 'border-orange-500/30 hover:border-orange-500/50',
      bg: 'bg-orange-500/20',
      gradient: 'from-orange-500/10 to-orange-600/5',
      text: 'text-orange-400'
    },
    green: {
      border: 'border-green-500/30 hover:border-green-500/50',
      bg: 'bg-green-500/20',
      gradient: 'from-green-500/10 to-green-600/5',
      text: 'text-green-400'
    },
    red: {
      border: 'border-red-500/30 hover:border-red-500/50',
      bg: 'bg-red-500/20',
      gradient: 'from-red-500/10 to-red-600/5',
      text: 'text-red-400'
    },
    emerald: {
      border: 'border-emerald-500/30 hover:border-emerald-500/50',
      bg: 'bg-emerald-500/20',
      gradient: 'from-emerald-500/10 to-emerald-600/5',
      text: 'text-emerald-400'
    },
    cyan: {
      border: 'border-cyan-500/30 hover:border-cyan-500/50',
      bg: 'bg-cyan-500/20',
      gradient: 'from-cyan-500/10 to-cyan-600/5',
      text: 'text-cyan-400'
    },
    pink: {
      border: 'border-pink-500/30 hover:border-pink-500/50',
      bg: 'bg-pink-500/20',
      gradient: 'from-pink-500/10 to-pink-600/5',
      text: 'text-pink-400'
    },
    yellow: {
      border: 'border-yellow-500/30 hover:border-yellow-500/50',
      bg: 'bg-yellow-500/20',
      gradient: 'from-yellow-500/10 to-yellow-600/5',
      text: 'text-yellow-400'
    },
    indigo: {
      border: 'border-indigo-500/30 hover:border-indigo-500/50',
      bg: 'bg-indigo-500/20',
      gradient: 'from-indigo-500/10 to-indigo-600/5',
      text: 'text-indigo-400'
    }
  };
  
  return colorMap[color] || colorMap.blue;
};
